var vn='0.9.25';export default vn;